import SceButton from "../../Common/CommonComponents/sceButton";
import classes from "./LanguagePopup.scss";
import { getLocalizedStrings } from '../centralizedLocalizedString';
import FocusTrap from 'focus-trap-react';
import RadioGroup from '../common/LanguageRadioGroup';
import LanguageCard from "./LanguageCard";
class LanguagePopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedLanguage: this.props.defaultLanguage, selectedLanguageCode: '', outlineStyle: '', validStyle: '',
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.strings = getLocalizedStrings('CustomerPreference');
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    }
    componentDidMount() {

        document.addEventListener('mousedown', this.handleClickOutside);
    }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.props.onCancelLangHandler();
        //  alert("clicked");
    
        }
    }  
    onLanguageRadioClick = (e, languageObj) => {
        this.setState({ selectedLanguage: languageObj.language, selectedLanguageCode: languageObj.languageCode1 });
    }
    
    onLanguageRadioFocus = (e) => {
        this.setState({outlineStyle: e.target.value});
    }

    onLanguageRadioBlur = (e) => {
        this.setState({outlineStyle: ""});
    }
    render() {
        let LanguagesToShow =
            <div>
                {this.props.availableLanguages.map((languageObj, i) => {
                    return (
                        <div key={'radio' + i}>
                            <RadioGroup
                                setName={'editLanguageRadioOptions'}
                                options={[languageObj.language]}
                                type='radio'
                                validStyle={this.state.validStyle}
                                radioOutLineFlag={this.state.outlineStyle}
                                selectedOptions={this.state.selectedLanguage}
                                onClick={(event) => this.onLanguageRadioClick(event, languageObj)}
                                onFocus={this.onLanguageRadioFocus}
                                onBlur={this.onLanguageRadioBlur}
                            />
                        </div>);
                })
                }
            </div>;
        let errorCard = this.props.isModifyLangError ?
            <div className={classes.sceNotificationLanguageErrorMessageContainer}>
                <p><img src={this.warningImg} alt="Warning Image" /></p>
                <span>{this.strings.modifyLanguageError}</span>
                <div className={classes.sceNotificationLanguageResubmitLink}>
                    <a href="javascript::void(0)" onClick={() => this.props.onSaveLanguageHandler(this.state.selectedLanguage, this.state.selectedLanguageCode)}>{this.strings.clickReSubmitText}</a>
                </div>
            </div>
            : null;

        let languageSecondColumnStart = Math.ceil((LanguagesToShow.props.children.length) / 2);
        let languageColumn1 = LanguagesToShow.props.children.slice(0,languageSecondColumnStart);
        let languageColumn2 = LanguagesToShow.props.children.slice(languageSecondColumnStart);

        return (
            <FocusTrap 
            focusTrapOptions={{
               allowOutsideClick: true,
           }}
           >
                <div>
                    <div tabIndex="0" className={classes.sceOverlay}>
                        <div className={classes.sceOverlayContent}>
                            <div ref={this.setWrapperRef} className={classes.sceDialogBox}>
                                <div className='row'>
                                    <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.strings.editLanguagePopupHeader}<button className={classes.sceNotificationLanguageIconClose}  onClick={this.props.onCancelLangHandler}><img src={this.closeIcon} alt="Close Icon" /></button></div>
                                </div>
                                {errorCard}
                                <div className={classes.sceNotificationLanguageContainer}>
                                    <div className='row'>
                                        <div className={'col-md-6'}>{languageColumn1}</div>
                                        <div className={'col-md-6'}>{languageColumn2}</div>
                                    </div>
                                </div>
                                <div className="text-align-center">
                                    <div className={classes.sceNotificationLanguageButton}>
                                        <div className={classes.sceNotificationLanguageSaveBtn}>
                                            <SceButton
                                                id="sceNotificationLanguageSave"
                                                buttonType="primary"
                                                value={this.strings.save}
                                                onClick={() => this.props.onSaveLanguageHandler(this.state.selectedLanguage, this.state.selectedLanguageCode)}
                                            />
                                        </div>
                                        <div className={classes.sceNotificationLanguageCancelBtn}>
                                            <SceButton
                                                id="sceNotificationLanguageCancel"
                                                buttonType="sceCancel"
                                                value={this.strings.cancel}
                                                onClick={this.props.onCancelLangHandler}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FocusTrap>);
    }
}
export default LanguagePopup;
